import { classNames } from '@/utils/class-names';
import { motion, AnimatePresence } from 'framer-motion';
import { TooltipPortal } from '@/components/TooltipPortal';
import { useRef, useEffect, useState } from 'react';

interface TooltipProps {
  label: string;
  percentage: number;
  value: number;
  visible: boolean;
  className?: string;
  top?: number;
}

const Tooltip: React.FC<TooltipProps> = ({ percentage, label, value, visible, className, top = 0 }: TooltipProps) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (tooltipRef.current) {
      const rect = tooltipRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top + window.scrollY - 60 + top,
        left: rect.left + rect.width / 2 + window.scrollX,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <div ref={tooltipRef} style={{ position: 'relative' }}>
      <AnimatePresence>
        {visible && (
          <TooltipPortal>
            <motion.div
              style={{
                position: 'absolute',
                top: position.top,
                left: position.left,
                pointerEvents: 'none',
              }}
              className={classNames('w-36 -translate-x-1/2 transform shadow-lg', className || '')}
              initial={{ opacity: 0, y: -10, x: '-50%' }}
              animate={{ opacity: 1, y: '-50%', x: '-50%' }}
              exit={{ opacity: 0, y: -10, x: '-50%' }}
              transition={{ duration: 0.3 }}>
              <div className="relative bg-gradient-to-b from-white to-[#D7E7F7] p-3 text-left text-[#263238]">
                <p className="text-sh-11-14 font-normal">{label}</p>
                <p className="text-sh-11-14 font-bold">
                  Responses: {percentage}% ({value})
                </p>
                <div className="absolute bottom-[-6px] left-1/2 h-0 w-0 -translate-x-1/2 transform border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-[#D7E7F7]" />
              </div>
            </motion.div>
          </TooltipPortal>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Tooltip;
